import React, { useState } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Link, useNavigate } from "react-router-dom";
import PageHeader from "../Components/PageHeader";
import { patientFileuploader } from "../network/Network";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import Fileuploader from "../Components/Fileuploader";

const UserSignUpDetail = () => {
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const token = useSelector((state) => state?.Auth?.token);

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleCancelClick = () => {
    setFile(null);
  };

  const handleDeleteFile = () => {
    document.getElementById("file-input").value = "";
    setFile(null); // Reset the state
  };

  // File Uploader Functionality 
  const fileUploader = (e) => {
    e.preventDefault();

    if (!file) {
      Swal.fire({
        position: "center",
        icon: "error",
        text: "Kindly upload Report",
        showConfirmButton: false,
        timer: 1500,
      });
    }
    let data = {
      reports: [file],
    };

    patientFileuploader(data, token)
      .then((res) => {
        Swal.fire({
          position: "center",
          icon: "success",
          text: "Medical Reports has been uploaded successfully",
          showConfirmButton: false,
          timer: 1500,
        });
        navigate("/personal-info");
        setFile("");
      })
      .catch((err) => {});
  };
  // ==========================
  return (
    <>
      <Header />
      <PageHeader pagename="Upload Medical Reports" />
      <section className="signup">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 mx-auto">
              <div className="signup-wrappper">
                <h2 className="main-heading-font dark-color  level-2 text-center mt-3  mb-4">
                  Upload your Medical Report{" "}
                </h2>
                <Fileuploader />
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default UserSignUpDetail;
